<app-navbar />
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Processando, por favor aguarde... </p>
</ngx-spinner>
<div class="container-fluid">
    <div *ngIf="servicoDetalhes" class="servico-detalhes-container">
        <div class="servico-detalhes-content" #conteudoModal>
            <div class="header bg-gradient-info">
                <h5 class="modal-title"></h5>
                <form class="form-cadastro-container form">
                    <div class="top-row">
                        <div class="title-block">
                            <div class="small-label">Vistoria de {{ tipo === 'recadastro' ? 'Recadastro' : 'Cadastro' }}
                            </div>
                        </div>
                        <div class="os-badge" aria-label="Número da Vistoria">
                            <div class="os-label">Vistoria nº</div>
                            <div class="os-number"> {{ servicoDetalhes?.numeroOS || servicoDetalhes?.numeroOs ||
                                servicoDetalhes?.numeroOS || '-' }}</div>
                        </div>
                    </div>
                    <fieldset>
                        <legend>DADOS DO CONSUMIDOR</legend>
                        <div class="grid-4">
                            <div *ngIf="servicoDetalhes.matricula">
                                <label>Matrícula</label>
                                <span>{{ servicoDetalhes.matricula }}</span>
                                <!-- Matricula não precisa de flag de validação -->
                            </div>
                            <div>
                                <label>Nome do Consumidor</label>
                                <span>{{ servicoDetalhes.nomeConsumidor || '-' }}</span>
                                <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                    [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                    campoKey="NOME_CONSUMIDOR">
                                </app-field-verify-toggle>
                                <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                    [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                    campoKey="NOME_CONSUMIDOR">
                                </app-field-verify-toggle>
                            </div>
                            <div>
                                <label>Documento</label>
                                <span>
                                        <ng-container *ngIf="servicoDetalhes.tipoUtilizacao?.toLowerCase() === 'domiciliar'; else showCnpj">
                                        {{ maskCpf(servicoDetalhes.cpf) || '-' }}
                                    </ng-container>
                                    <ng-template #showCnpj>
                                        {{ maskCnpj(servicoDetalhes.Cnpj) || '-' }}
                                    </ng-template>
                                </span>
                                <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                    [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                    [campoKey]="servicoDetalhes.tipoUtilizacao?.toLowerCase() === 'domiciliar' ? 'CPF' : 'CNPJ'">
                                </app-field-verify-toggle>
                                <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                    [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                    [campoKey]="servicoDetalhes.tipoUtilizacao?.toLowerCase() === 'domiciliar' ? 'CPF' : 'CNPJ'">
                                </app-field-verify-toggle>
                            </div>
                            <div>
                                <label>Telefone</label>
                                <span>{{ maskTelefone(servicoDetalhes.telefone) || '-' }}</span>
                                <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                    [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                    campoKey="TELEFONE">
                                </app-field-verify-toggle>
                                <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                    [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id" campoKey="TELEFONE">
                                </app-field-verify-toggle>
                            </div>
                        </div>
                        <div class="grid-3">
                            <div>
                                <label>Referência</label>
                                <span>{{ servicoDetalhes.referencia || '-' }}</span>
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div>
                                <label>Número Imóvel</label>
                                <span>{{ servicoDetalhes.numeroImovel || '-' }}</span>
                                <!-- flag removida conforme escopo -->
                            </div>

                            <div>
                                <label>Loja/Loc</label>
                                <span>{{ servicoDetalhes.lojLoc || '-' }}</span>
                                <!-- flag removida conforme escopo -->
                            </div>
                        </div>
                        <div class="grid-3">
                            <div>
                                <label>{{ dataCadastroLabel }}</label>
                                <span>{{ dataCadastroValue ? (dataCadastroValue | date: 'dd/MM/yyyy HH:mm') : '-'
                                    }}</span>
                            </div>
                            <div>
                                <label>Email</label>
                                <span>{{ servicoDetalhes.email || '-' }}</span>
                                <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                    [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                    campoKey="EMAIL">
                                </app-field-verify-toggle>
                                <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                    [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id" campoKey="EMAIL">
                                </app-field-verify-toggle>
                            </div>
                            <div>
                                <label>Tipo Utilização</label>
                                <span>{{ servicoDetalhes.tipoUtilizacao || '-' }}</span>
                                <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                    [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                    campoKey="TIPO_UTILIZACAO">
                                </app-field-verify-toggle>
                                <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                    [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                    campoKey="TIPO_UTILIZACAO">
                                </app-field-verify-toggle>
                            </div>
                        </div>
                    </fieldset>

                </form>

                <fieldset *ngIf="servicoDetalhes.possuiDebito">
                    <div>
                        <label>Possui Débito</label>
                        <input type="text" [value]="servicoDetalhes.possuiDebito ? 'Sim' : 'Não'" readonly
                            class="campo-readonly" />
                    </div>
                    <div class="grid-2 mb-2" *ngIf="servicoDetalhes.valorDebito || servicoDetalhes.dataInicioDebito">
                        <div *ngIf="servicoDetalhes.valorDebito">
                            <label>Valor do Débito</label>
                            <input type="text" [value]="servicoDetalhes.valorDebito | currency:'BRL':'symbol':'1.2-2'"
                                readonly class="campo-readonly" />
                        </div>
                        <div *ngIf="servicoDetalhes.dataInicioDebito">
                            <label>Data Início Débito</label>
                            <input type="text" [value]="servicoDetalhes.dataInicioDebito | date:'dd/MM/yyyy'" readonly
                                class="campo-readonly" />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <legend class="mb-2">Endereço</legend>
                    <div class="grid-3 mb-2">
                        <div>
                            <label>CEP</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.cep || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag CEP removida conforme solicitação -->
                        </div>
                        <div>
                            <label>Logradouro</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.logradouro || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag Logradouro removida conforme escopo -->
                        </div>
                        <div>
                            <label>Complemento</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.complemento || '-'" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="COMPLEMENTO">
                            </app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id" campoKey="COMPLEMENTO">
                            </app-field-verify-toggle>
                        </div>
                        <div>
                            <label>Bairro</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.bairro || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Localidade</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.cidade || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag Localidade (CIDADE) removida conforme solicitação -->
                        </div>
                        <div>
                            <label>UF</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.estado || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Número</label>
                            <input type="text" [value]="servicoDetalhes.endereco?.numero || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                    </div>
                </fieldset>

                <fieldset
                    *ngIf="servicoDetalhes.numeroHidrometro || servicoDetalhes.marcacao || servicoDetalhes.seloReloj || servicoDetalhes.seloVirola || servicoDetalhes.ramal || servicoDetalhes.direto !== undefined || servicoDetalhes.haCisterna !== undefined || servicoDetalhes.haReservatorioElevado !== undefined || servicoDetalhes.tipoEconomia || servicoDetalhes.haPiscina !== undefined">
                    <legend class="mb-2">ÁGUA</legend>
                    <div class="grid-3 mb-2">
                        <div>
                            <label>Nº Hidrômetro</label>
                            <input type="text" [value]="servicoDetalhes.numeroHidrometro || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Marcação</label>
                            <input type="text" [value]="servicoDetalhes.marcacao || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Selo Reloj.</label>
                            <input type="text" [value]="servicoDetalhes.seloReloj || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Selo Virola</label>
                            <input type="text" [value]="servicoDetalhes.seloVirola || '-'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Ramal</label>
                            <input type="text" [value]="servicoDetalhes.ramal || '-'" readonly class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                        <div>
                            <label>Direto</label>
                            <input type="text"
                                [value]="servicoDetalhes.direto === undefined ? '-' : (servicoDetalhes.direto ? 'Sim' : 'Não')"
                                readonly class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                    </div>

                    <div class="grid-1 mb-2">

                        <fieldset *ngIf="servicoDetalhes.haCisterna !== undefined">
                            <h4>Cisterna</h4>
                            <label>Há cisterna?</label>
                            <input type="text" [value]="servicoDetalhes.haCisterna ? 'Sim' : 'Não'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                            <div *ngIf="servicoDetalhes.haCisterna && servicoDetalhes.capacidadeCisternaInformada">
                                <label>Capacidade Informada</label>
                                <input type="text" [value]="servicoDetalhes.capacidadeCisternaInformada" readonly
                                    class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoDetalhes.haCisterna && servicoDetalhes.observacoesCisterna">
                                <label>Observações</label>
                                <textarea readonly class="campo-readonly"
                                    rows="2">{{ servicoDetalhes.observacoesCisterna }}</textarea>
                                <!-- flag removida conforme escopo -->
                            </div>
                        </fieldset>

                        <fieldset *ngIf="servicoDetalhes.haReservatorioElevado !== undefined">
                            <h4>Reservatório Elevado</h4>
                            <label>Há Reservatórios Elevados?</label>
                            <input type="text" [value]="servicoDetalhes.haReservatorioElevado ? 'Sim' : 'Não'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                            <div
                                *ngIf="servicoDetalhes.haReservatorioElevado && servicoDetalhes.capacidadeReservatorioElevadoInformada">
                                <label>Capacidade Informada</label>
                                <input type="text" [value]="servicoDetalhes.capacidadeReservatorioElevadoInformada"
                                    readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div
                                *ngIf="servicoDetalhes.haReservatorioElevado && servicoDetalhes.observacoesReservatorioElevado">
                                <label>Observações</label>
                                <textarea readonly class="campo-readonly"
                                    rows="2">{{ servicoDetalhes.observacoesReservatorioElevado }}</textarea>
                                <!-- flag removida conforme escopo -->
                            </div>
                        </fieldset>

                        <fieldset *ngIf="servicoDetalhes.haPiscina !== undefined">
                            <h4>Piscina</h4>
                            <label>Existe Piscina?</label>
                            <input type="text" [value]="servicoDetalhes.haPiscina ? 'Sim' : 'Não'" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                            <div *ngIf="servicoDetalhes.haPiscina && servicoDetalhes.dimensoesPiscina">
                                <label>Dimensões:</label>
                                <input type="text" [value]="servicoDetalhes.dimensoesPiscina" readonly
                                    class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                        </fieldset>
                    </div>
                </fieldset>

                <fieldset *ngIf="servicoDetalhes.tipoEconomia">
                    <legend class="mb-2">Economias</legend>
                    <div class="grid-3 mb-2">
                        <div>
                            <label>Tipos de Economias</label>
                            <input type="text" [value]="servicoDetalhes.tipoEconomia || '-'" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="TIPO_ECONOMIA"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="TIPO_ECONOMIA"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.dUnica">
                            <label>Sub Categoria</label>
                            <input type="text" [value]="servicoDetalhes.dUnica" readonly class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="D_UNICA"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="D_UNICA"></app-field-verify-toggle>
                        </div>
                        <div>
                            <label>Número de Economias</label>
                            <input type="text" [value]="servicoDetalhes.numeroDeEconomias || '-'" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_DE_ECONOMIAS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_DE_ECONOMIAS"></app-field-verify-toggle>
                        </div>
                    </div>

                    <!-- DOMICILIAR -->
                    <div class="grid-3 mb-2"
                        *ngIf="servicoDetalhes.tipoEconomia === 'DOMICILIAR' && (servicoDetalhes.numeroDeQuartos || servicoDetalhes.numeroDeSalas || servicoDetalhes.numeroWcPav)">
                        <div *ngIf="servicoDetalhes.numeroDeQuartos">
                            <label>Nº Quartos</label>
                            <input type="text" [value]="servicoDetalhes.numeroDeQuartos" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_DE_QUARTOS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_DE_QUARTOS"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.numeroDeSalas">
                            <label>Nº Salas</label>
                            <input type="text" [value]="servicoDetalhes.numeroDeSalas" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_DE_SALAS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_DE_SALAS"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.numeroWcPav">
                            <label>Nº WC/PAV</label>
                            <input type="text" [value]="servicoDetalhes.numeroWcPav" readonly class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_WC_PAV"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_WC_PAV"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.banheiros">
                            <label>Banheiros</label>
                            <input type="text" [value]="servicoDetalhes.banheiros" readonly class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="BANHEIROS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="BANHEIROS"></app-field-verify-toggle>
                        </div>
                    </div>

                    <!-- Comércio -->
                    <div class="grid-3 mb-2" *ngIf="servicoDetalhes.tipoEconomia === 'COMERCIO'">
                        <div *ngIf="servicoDetalhes.numeroDeAlunos">
                            <label>Alunos</label>
                            <input type="text" [value]="servicoDetalhes.numeroDeAlunos" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_ALUNOS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_ALUNOS"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.banheiros">
                            <label>Banheiros</label>
                            <input type="text" [value]="servicoDetalhes.banheiros" readonly class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="BANHEIROS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="BANHEIROS"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.numeroDeBoxes">
                            <label>Nº Boxes</label>
                            <input type="text" [value]="servicoDetalhes.numeroDeBoxes" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_BOXES"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="NUMERO_BOXES"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.tipoComercio">
                            <label>Tipo Comércio</label>
                            <input type="text" [value]="servicoDetalhes.tipoComercio" readonly class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="TIPO_COMERCIO"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="TIPO_COMERCIO"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.areaMetroQuadrado">
                            <label>Área (m²)</label>
                            <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="AREA_M2"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="AREA_M2"></app-field-verify-toggle>
                        </div>
                    </div>

                    <!-- Indústria -->
                    <div class="grid-3 mb-2" *ngIf="servicoDetalhes.tipoEconomia === 'INDUSTRIA'">
                        <div *ngIf="servicoDetalhes.banheiros">
                            <label>Banheiros</label>
                            <input type="text" [value]="servicoDetalhes.banheiros" readonly class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="BANHEIROS"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="BANHEIROS"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.tipoIndustria">
                            <label>Tipo Indústria</label>
                            <input type="text" [value]="servicoDetalhes.tipoIndustria" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="TIPO_INDUSTRIA"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="TIPO_INDUSTRIA"></app-field-verify-toggle>
                        </div>
                        <div *ngIf="servicoDetalhes.areaMetroQuadrado">
                            <label>Área (m²)</label>
                            <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly
                                class="campo-readonly" />
                            <app-field-verify-toggle *ngIf="tipo === 'recadastro'" tipo="recadastro"
                                [recadastroId]="servicoDetalhes.recadastroId || servicoDetalhes.id"
                                campoKey="AREA_M2_INDUSTRIA"></app-field-verify-toggle>
                            <app-field-verify-toggle *ngIf="tipo === 'cadastro'" tipo="cadastro"
                                [cadastroId]="servicoDetalhes.cadastroId || servicoDetalhes.id"
                                campoKey="AREA_M2_INDUSTRIA"></app-field-verify-toggle>
                        </div>
                    </div>
                </fieldset>

                <fieldset *ngIf="hasEsgotoAny()">
                    <legend class="mb-2">ESGOTO</legend>
                    <div *ngIf="servicoDetalhes.haColetor !== undefined || servicoYes(servicoDetalhes.coletor)">
                        <label>Tem coletor?</label>
                        <input type="text"
                            [value]="servicoYes(servicoDetalhes.haColetor) ? 'Sim' : (servicoYes(servicoDetalhes.coletor) ? 'Sim' : 'Não')"
                            readonly class="campo-readonly" />
                        <!-- flag removida conforme escopo -->
                    </div>

                    <div *ngIf="hasEsgotoAny()">
                        <label>Efluente encaminhado para:</label>
                        <div class="grid-4 mb-2">
                            <div *ngIf="servicoYes(servicoDetalhes.coletor)">
                                <label>Coletor</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoYes(servicoDetalhes.gap)">
                                <label>GAP</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoYes(servicoDetalhes.rio)">
                                <label>RIO</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoYes(servicoDetalhes.valao)">
                                <label>VALÃO</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoYes(servicoDetalhes.focaFiltro)">
                                <label>Fossa/Filtro</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoYes(servicoDetalhes.vala)">
                                <label>Vala</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                            <div *ngIf="servicoYes(servicoDetalhes.sumidouro)">
                                <label>Sumidouro</label>
                                <input type="text" value="Sim" readonly class="campo-readonly" />
                                <!-- flag removida conforme escopo -->
                            </div>
                        </div>
                        <div *ngIf="servicoDetalhes.tipoValaValao">
                            <label>A vala ou valão é de:</label>
                            <input type="text" [value]="servicoDetalhes.tipoValaValao" readonly
                                class="campo-readonly" />
                            <!-- flag removida conforme escopo -->
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <legend class="mb-2">FOTOS DO LOCAL</legend>
                    <div class="fotos-grid mb-2">
                        <div class="foto-item" *ngFor="let foto of servicoDetalhes.fotos; let i = index">
                            <div class="foto-wrapper">
                                <img [src]="getFullImageUrl(foto.url)" alt="Foto do Local" class="foto-local"
                                    (click)="abrirModalFoto(foto.url)"
                                    [style.transform]="'rotate(' + getRotacaoMiniatura(foto.url || '') + 'deg)'"
                                    [style.transition]="'transform 0.3s'" />
                            </div>
                            <div class="foto-actions mt-2">
                                <a *ngIf="foto?.latitude && foto?.longitude"
                                    [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude"
                                    target="_blank" class="btn btn-outline-success btn-sm">
                                    <i class="bi bi-geo-alt-fill"></i>Mapa
                                </a>

                                <div class="rotate-buttons">
                                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                                        (click)="$event.stopPropagation(); girarMiniatura(foto.url || '', 'esquerda')" title="Girar esquerda">
                                        <i class="bi bi-arrow-counterclockwise"></i>
                                    </button>
                                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                                        (click)="$event.stopPropagation(); girarMiniatura(foto.url || '', 'direita')" title="Girar direita">
                                        <i class="bi bi-arrow-clockwise"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="foto-verify mt-2">
                                <!-- flags de foto removidas conforme escopo -->
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!servicoDetalhes.fotos?.length" class="alert alert-warning">
                        Nenhuma foto disponível.
                    </div>
                </fieldset>

                <fieldset>
                    <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
                    <div>
                        <label>Descrição da Conclusão</label>
                        <textarea readonly class="campo-readonly"
                            rows="6">{{ servicoDetalhes.outrasInformacoes }}</textarea>
                        <!-- flag OUTRAS_INFORMACOES removida conforme escopo -->
                    </div>
                </fieldset>

                <fieldset class="fotos">
                    <legend class="mb-2">FOTOS DE DOCUMENTOS</legend>
                    <div class="fotos-grid mb-2">
                        <div class="foto-item" *ngFor="let fotoDoc of servicoDetalhes.fotosDocumento; let j = index">
                            <div class="foto-wrapper">
                                <img [src]="getFullImageUrl(fotoDoc.url)" alt="Foto do Documento" class="foto-local"
                                    (click)="abrirModalFoto(fotoDoc.url)"
                                    [style.transform]="'rotate(' + getRotacaoMiniatura(fotoDoc.url || '') + 'deg)'"
                                    [style.transition]="'transform 0.3s'" />
                            </div>
                            <div class="foto-actions mt-2">
                                <a *ngIf="fotoDoc?.latitude && fotoDoc?.longitude"
                                    [href]="'https://www.google.com/maps?q=' + fotoDoc.latitude + ',' + fotoDoc.longitude"
                                    target="_blank" class="btn btn-outline-success btn-sm">
                                    <i class="bi bi-geo-alt-fill"></i> Mapa
                                </a>

                                <div class="rotate-buttons">
                                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                                        (click)="$event.stopPropagation(); girarMiniatura(fotoDoc.url || '', 'esquerda')" title="Girar esquerda">
                                        <i class="bi bi-arrow-counterclockwise"></i>
                                    </button>
                                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                                        (click)="$event.stopPropagation(); girarMiniatura(fotoDoc.url || '', 'direita')" title="Girar direita">
                                        <i class="bi bi-arrow-clockwise"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="foto-verify mt-2">
                                <!-- flags de foto de documento removidas conforme escopo -->
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!servicoDetalhes.fotosDocumento?.length" class="alert alert-warning">
                        Nenhuma foto disponível.
                    </div>
                </fieldset>

                <fieldset>
                    <legend>LOCALIZAÇÃO DO {{ CadastroSelecionado?.tipo === 'recadastro' ? 'RECADASTRO' : 'CADASTRO'
                        }}</legend>
                    <div class="grid-2" style="gap: 24px;">
                        <!-- Card Início -->
                        <div
                            style="background: #f4f8fb; border-radius: 12px; padding: 20px 18px; border: 1px solid #e0e0e0; box-shadow: 0 2px 8px rgba(52,152,219,0.07); display: flex; flex-direction: column; align-items: flex-start;">
                            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
                                <i class="fas fa-play-circle" style="color: #3498db; font-size: 1.5rem;"></i>
                                <h4 style="margin:0; color:#2c3e50; font-weight:700; font-size:1.1rem;">
                                    Início do {{ CadastroSelecionado?.tipo === 'recadastro' ? 'Recadastro' :
                                    'Cadastro' }}
                                </h4>

                            </div>
                            <div class="info-item" style="margin-bottom: 8px;">
                                <label style="font-weight:500;">Data/Hora:</label>
                                <span style="background:transparent; border:none; padding:0; color:#34495e;">
                                    {{ CadastroSelecionado?.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss' }}
                                </span>
                            </div>
                            <div class="info-item">
                                <label style="font-weight:500;">Coordenadas:</label>
                                <span
                                    style="background: #e3f2fd; color: #1565c0; border-radius: 4px; padding: 4px 8px; font-family: monospace;">
                                    {{ CadastroSelecionado?.latitudeInicio || 'N/A' }}, {{
                                    CadastroSelecionado?.longitudeInicio || 'N/A' }}
                                </span>
                                <div class="mt-2">
                                    <a *ngIf="CadastroSelecionado?.latitudeInicio && CadastroSelecionado?.longitudeInicio"
                                        [href]="'https://www.google.com/maps?q=' + (CadastroSelecionado?.latitudeInicio) + ',' + (CadastroSelecionado?.longitudeInicio)"
                                        target="_blank" class="btn btn-outline-success btn-sm ms-1 mt-2">
                                        <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- Card Fim -->
                        <div
                            style="background: #f4f8fb; border-radius: 12px; padding: 20px 18px; border: 1px solid #e0e0e0; box-shadow: 0 2px 8px rgba(52,152,219,0.07); display: flex; flex-direction: column; align-items: flex-start;">
                            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
                                <i class="fas fa-flag-checkered" style="color: #e67e22; font-size: 1.5rem;"></i>
                                <h4 style="margin:0; color:#2c3e50; font-weight:700; font-size:1.1rem;">
                                    Fim do {{ CadastroSelecionado?.tipo === 'recadastro' ? 'Recadastro' : 'Cadastro'
                                    }}
                                </h4>

                            </div>
                            <div class="info-item" style="margin-bottom: 8px;">
                                <label style="font-weight:500;">Data/Hora:</label>
                                <span style="background:transparent; border:none; padding:0; color:#34495e;">
                                    {{ CadastroSelecionado?.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss' }}
                                </span>
                            </div>
                            <div class="info-item">
                                <label style="font-weight:500;">Coordenadas:</label>
                                <span
                                    style="background: #fff3e0; color: #e65100; border-radius: 4px; padding: 4px 8px; font-family: monospace;">
                                    {{ CadastroSelecionado?.latitudeFim || 'N/A' }}, {{
                                    CadastroSelecionado?.longitudeFim || 'N/A' }}
                                </span>
                                <div class="mt-2">
                                    <a *ngIf="CadastroSelecionado?.latitudeFim && CadastroSelecionado?.longitudeFim"
                                        [href]="'https://www.google.com/maps?q=' + (CadastroSelecionado?.latitudeFim) + ',' + (CadastroSelecionado?.longitudeFim)"
                                        target="_blank" class="btn btn-outline-danger btn-sm ms-1 mt-2">
                                        <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Mapa para mostrar as coordenadas -->
                    <div class="cadastro-map-container"
                        *ngIf="CadastroSelecionado?.latitudeInicio && CadastroSelecionado?.longitudeInicio"
                        style="margin-top: 18px;">
                        <div id="mapCadastro" class="cadastro-map"
                            style="height: 320px; border-radius: 12px; border: 1.5px solid #e0e0e0;"></div>
                    </div>
                    <div *ngIf="!CadastroSelecionado?.latitudeInicio || !CadastroSelecionado?.longitudeInicio"
                        class="alert alert-info" style="margin-top: 18px;">
                        <i class="fas fa-info-circle"></i> Coordenadas de localização não disponíveis para este
                        cadastro.
                    </div>
                </fieldset>

                <fieldset>
                    <legend class="mb-2">Dados do Acompanhante</legend>
                    <div class="grid-3 mb-2">
                        <div>
                            <label>Nome do Acompanhante</label>
                            <input type="text" [value]="servicoDetalhes.nomeAcompanhante || '-'" readonly
                                class="campo-readonly" />
                        </div>
                        <div>
                            <label>CPF do Acompanhante</label>
                            <input type="text" [value]="maskCpf(servicoDetalhes.cpfAcompanhante)" readonly
                                class="campo-readonly" />
                        </div>
                        <div>
                            <label>Telefone do Acompanhante</label>
                            <input type="text" [value]="maskTelefone(servicoDetalhes.telefoneAcompanhante)" readonly
                                class="campo-readonly" />
                        </div>
                    </div>
                    <div>
                        <label>Assinatura do Acompanhante:</label>
                        <div class="signature-container">
                            <img *ngIf="servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante"
                                [src]="getFullImageUrl(servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante)"
                                alt="Assinatura do Acompanhante" class="signature-image"
                                (click)="abrirModalFoto(servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante)">
                            <div *ngIf="!servicoDetalhes.assinaturaAcompanhante?.url && !servicoDetalhes.assinaturaAcompanhante"
                                class="sem-dados-campo">
                                Não informado
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <legend class="mb-2">Dados do Vistoriador</legend>
                    <div class="grid-2 mb-2">
                        <div>
                            <label>Nome do Vistoriador</label>
                            <input type="text" [value]="servicoDetalhes.nomeVistoriante || '-'" readonly
                                class="campo-readonly" />
                        </div>
                        <div>
                            <label>Data da Vistoria</label>
                            <input type="text" [value]="servicoDetalhes.dataCadastro | date:'dd/MM/yyyy HH:mm'" readonly
                                class="campo-readonly" />
                        </div>
                    </div>
                    <div class="grid-1 vistoriador-foto mb-2">
                        <div
                            *ngIf="servicoDetalhes.fotoVistoriante && servicoDetalhes.fotoVistoriante !== 'URL_PADRAO_SEM_IMAGEM'">
                            <label>Foto do Vistoriador</label>
                            <div class="foto-vistoriador" (click)="abrirModalFoto(servicoDetalhes.fotoVistoriante)">
                                <img [src]="getFullImageUrl(servicoDetalhes.fotoVistoriante)" alt="Foto do Vistoriador"
                                    class="foto-vistoriador">
                            </div>
                        </div>
                        <div *ngIf="!servicoDetalhes.fotoVistoriante || servicoDetalhes.fotoVistoriante === 'URL_PADRAO_SEM_IMAGEM'"
                            class="alert alert-warning">
                            Foto não disponível
                        </div>
                    </div>
                    <div>
                        <label>Assinatura do Vistoriador:</label>
                        <div class="signature-container">
                            <img *ngIf="servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url"
                                [src]="getFullImageUrl(servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url)"
                                alt="Assinatura do Vistoriador" class="signature-image"
                                (click)="abrirModalFoto(servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url)">
                            <div *ngIf="!servicoDetalhes.assinaturaVistoriador && !servicoDetalhes.assinaturaVistoriante?.url"
                                class="sem-dados-campo">
                                Não informado
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <legend class="mb-2">Validação da vistoria</legend>
                    <div class="d-flex justify-content-center gap-3 mb-3">
                        <!-- Botão Validar -->
                        <button type="button" class="btn btn-lg validation-btn" [class.btn-success]="!statusProcessado"
                            [class.btn-outline-success]="statusProcessado && statusFinal === 'Validado'"
                            [class.d-none]="statusProcessado && statusFinal === 'Invalido'"
                            [disabled]="processandoStatus" (click)="confirmarValidacao()">
                            <span *ngIf="!processandoStatus || statusFinal !== 'Validado'">
                                <i class="bi bi-check-lg me-2"></i> Validar
                            </span>
                            <span *ngIf="processandoStatus && statusFinal === 'Validado'"
                                class="d-flex align-items-center">
                                <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                                Validando...
                            </span>
                            <span *ngIf="statusProcessado && statusFinal === 'Validado'" class="success-message">
                                <i class="bi bi-check-circle-fill me-2 text-success"></i>
                                <span class="text-success fw-bold">Validado com sucesso!</span>
                            </span>
                        </button>

                        <!-- Botão Invalidar -->
                        <button type="button" class="btn btn-lg validation-btn" [class.btn-danger]="!statusProcessado"
                            [class.btn-outline-danger]="statusProcessado && statusFinal === 'Invalido'"
                            [class.d-none]="statusProcessado && statusFinal === 'Validado'"
                            [disabled]="processandoStatus" (click)="invalidarServico()">
                            <span *ngIf="!processandoStatus || statusFinal !== 'Invalido'">
                                <i class="bi bi-x-lg me-2"></i> Invalidar
                            </span>
                            <span *ngIf="processandoStatus && statusFinal === 'Invalido'"
                                class="d-flex align-items-center">
                                <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                                Invalidando...
                            </span>
                            <span *ngIf="statusProcessado && statusFinal === 'Invalido'" class="error-message">
                                <i class="bi bi-x-circle-fill me-2 text-danger"></i>
                                <span class="text-danger fw-bold">Invalidado com sucesso!</span>
                            </span>
                        </button>
                    </div>

                    <!-- Mensagem de status -->
                    <div *ngIf="statusProcessado" class="alert" [class.alert-success]="statusFinal === 'Validado'"
                        [class.alert-danger]="statusFinal === 'Invalido'" [class.fade-in]="statusProcessado">
                        <div class="d-flex align-items-center justify-content-center">
                            <i
                                [class]="statusFinal === 'Validado' ? 'bi bi-check-circle-fill me-2' : 'bi bi-x-circle-fill me-2'"></i>
                            <strong>{{ statusFinal === 'Validado' ? 'Vistoria validada' : 'Vistoria invalida' }}
                                com
                                sucesso!</strong>
                        </div>
                    </div>
                </fieldset>
                <!-- Removido form duplicado e fechamento incorreto -->
                <div class="footer">
                    <button type="button" class="btn btn-danger me-2" (click)="exportarServicoParaPDF()">
                        <i class="bi bi-file-earmark-pdf-fill me-1"></i> Exportar PDF
                    </button>
                    <button type="button" class="btn btn-secondary" (click)="fecharModalDetalhes()">Fechar</button>
                </div>

                <!-- Modal de confirmação de invalidação -->
                <div class="modal fade show" tabindex="-1" *ngIf="mostrarModalInvalida"
                    style="display: flex; align-items: center; justify-content: center; z-index: 999999;">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header bg-gradient-info">
                                <h5 class="modal-title">
                                    Motivo da Invalidação
                                </h5>
                            </div>
                            <div class="modal-body">
                                <label for="motivoInvalido" class="form-label">Por favor, informe o motivo da
                                    invalidação <span class="text-danger">*</span></label>
                                <textarea id="motivoInvalido" class="form-control" [(ngModel)]="motivoInvalido" rows="4"
                                    [ngClass]="{'is-invalid': motivoInvalidoTouched && (!motivoInvalido || motivoInvalido.trim().length < 3)}"
                                    (blur)="motivoInvalidoTouched = true" required></textarea>
                                <div *ngIf="motivoInvalidoTouched && (!motivoInvalido || motivoInvalido.trim().length < 3)"
                                    class="invalid-feedback d-block">
                                    O motivo é obrigatório e deve ter pelo menos 3 caracteres.
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary"
                                    (click)="cancelarInvalidacao()">Cancelar</button>
                                <button type="button" class="btn btn-danger" (click)="confirmarInvalidacao()"
                                    [disabled]="!motivoInvalido || motivoInvalido.trim().length < 3">Confirmar
                                    Invalidação</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal de visualização de foto ampliada -->
                <div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto"
                    (click)="fecharModalFoto()">
                    <div class="modal-foto-content" (click)="$event.stopPropagation()">
                        <button type="button" class="btn-close-foto" (click)="fecharModalFoto()">
                            <i class="fas fa-times"></i>
                        </button>
                        <img [src]="fotoSelecionada" alt="Foto Ampliada" class="foto-ampliada"
                            [style.transform]="'rotate(' + rotacaoFoto + 'deg)'"
                            [style.transition]="'transform 0.3s'">
                    </div>
                </div>

                <!-- Container oculto para exportação completa -->
                <div #conteudoCompleto style="position: absolute; top: -9999px; left: -9999px; width: 1000px;">
                    <div [innerHTML]="htmlCompletoParaExportar"></div>
                </div>
            </div>
        </div>
    </div>
</div>